export default {
  UPDATED_STATE: 'updated_state',
  JOIN: 'join',
  LEAVE: 'leave',
  DISCONNECT: 'disconnect',
  DISPATCH: 'dispatch',
}